<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col">

          <!-- {{user}} -->
        
<div class="row mb-2">
  <div class="col"><h5>Email verification</h5></div>
</div>

        <div class="card">
          <div class="card-body">
<div class="container px-3 py-0 pb-2">
  <div class="text-center mb-3">{{user.email}}</div>
    
    <div v-if="user.email_verified_at" class="mt-2 text-center">
            <i class="fas fa-check-circle check-icon complete mr-2 fa-2x mb-2"></i>
            <div class="mt-2">Your email address is verified</div>
            </div>

<div v-else>    
<div class="text-center mb-2"><h1 class="badge badge-secondary number">1</h1></div>

<button v-if="sending" type="submit" class="btn btn-success col"><i class="fas fa-spinner fa-spin mr-2"></i>Sending verification code ...</button>
<button v-else type="submit" class="btn btn-dark col" @click="sendCode">Click here to send email verification code</button>
        
<div class="text-center mt-3"><h1 class="badge badge-secondary number">2</h1></div>
  <div class="form-group">
    <div class="text-center"><label>Enter email verification code</label></div>
    <input type="text" class="form-control text-center code" v-model="posted_email_code" maxlength="4">
  </div>
  
  <button v-if="checking" type="submit" class="btn btn-success col mb-3"><i class="fas fa-spinner fa-spin mr-2"></i>Checking code ...</button>
  <button v-else type="submit" class="btn btn-danger col mb-3" @click="checkCode">Submit</button>
  
</div>    
       
 </div>
               </div>
              <div>
            </div>
          </div>
        </div>
      </div>
    </div>

</template>
<script>
export default {
props: ['user'],

  data() {
    return {
      sending: false,
      checking: false,
      posted_email_code: '',
      code_error: '',
    };
  },

  created() {
    
  },

  methods: {

    checkCode() {

        if (this.posted_email_code !='' && this.posted_email_code != null) { 

          this.checking = true;

          axios
          .post("/check-email-code", {posted_email_code: this.posted_email_code})
          .then((response) => {

            // console.log(response.data.message);

            if (response.data.success) {
              this.user.email_verified_at = true;
            } else {
              this.showToaster2(response.data.message);
            }

            this.checking = false;

          })
          .catch(function (err) {
            console.log(err);
            this.checking = false;
          });

        } else { this.sweetfire('Please enter email code') }
      
      },

      sendCode() {

          this.sending = true;

          axios
          .post('/send-email-code')
          .then((response) => {

            this.showToaster('Please check your email');

            this.sending = false;

          })
          .catch(function (err) {
            console.log(err);
            this.sending = false;
          });
      
      },

      showToaster(text) {
      this.$toaster.success(text, { timeout: 2500 });
      },

    showToaster2(text) {
      this.$toaster.error(text, { timeout: 2500 });
    },

    sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },

  },
};
</script> 

<style scoped>
.number {
font-size: 1.0rem;
width: 40px;
border-radius: 50%;
background-color: #1c2b33;
font-weight: bold;
height: 40px;
}
.code {font-size:2rem; font-weight:bold;}
.complete { color: #28a745; }
input.form-control, input.form-control:focus {
  font-size: 2rem;
  font-weight: bold;
  background-color: #fff !important;
  border: 2px solid #1c2b33 !important;
  color: #1c2b33 !important;
 }
</style>